import Vue from 'vue';

Vue.directive('select', {
  bind(el, binding) {
    const [handleLongPress, handleClick] = binding.value;

    // Define variable
    let pressTimer: number | null = null;

    let pressed = false;

    // Run Function
    const handler = (e: MouseEvent | TouchEvent) => {
      handleLongPress(e);
    };

    // Define funtion handlers
    // Create timeout ( run function after 1s )
    const start = (e: TouchEvent) => {
      pressed = false;
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          // Run function
          handler(e);
          pressed = true;
        }, 300);
      }
    };

    // Cancel Timeout
    const cancel = () => {
      // Check if timer has a value or not
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    const click = (e: MouseEvent) => {
      e.preventDefault();
      if (!pressed) {
        if (e.shiftKey) {
          handleLongPress(e);
        } else {
          handleClick(e);
        }
      }
    };

    // Add Event listeners
    el.addEventListener('touchstart', start);
    // Cancel timeouts if this events happen
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchcancel', cancel);

    el.addEventListener('click', click);
  },
});
